import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { LoginService } from '../login/login.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { ChristmasService } from 'src/app/services/christmas.service';

@Component({
  selector: 'app-usuario-inativo',
  templateUrl: './usuario-inativo.component.html',
  styleUrls: ['./usuario-inativo.component.css']
})
export class UsuarioInativoComponent implements OnInit {

  userForm: UntypedFormGroup;
  dadosInativacao: any;
  isProgress: boolean = false;
  hidePassword: boolean = true;
  isChristmasMode: boolean = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private loginService: LoginService,
    private router: Router,
    private snackBar: SnackBarService,
    private dialog: MatDialog,
    private christmasService: ChristmasService
  ) {
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras?.state) {
      this.dadosInativacao = navigation.extras.state['dadosInativacao'];
    }
  }

  ngOnInit() {
    this.isChristmasMode = this.christmasService.isChristmasMode();
    this.userForm = this.formBuilder.group({
      login: [this.dadosInativacao?.login || '', [Validators.required, Validators.minLength(11), Validators.maxLength(11)]],
      password: ['', [Validators.required]]
    });
  }

  get formControls() { return this.userForm.controls; }

  voltarLogin() {
    this.router.navigateByUrl('/');
  }

  contartarAdministrador() {
    this.snackBar.showSnackBarInfo('Entre em contato com o administrador do sistema.');
  }

  togglePasswordVisibility() {
    this.hidePassword = !this.hidePassword;
  }

  formatarData(data: string): string {
    if (!data) return '';
    const date = new Date(data);
    return date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  private setDadosUsuario(data: any) {
    localStorage.setItem('user', JSON.stringify(data.modulos[0]));
  }

  private setModulos(data: any) {
    let mods: any = [];
    data.modulos.forEach(element => {
      mods.push({
        "id_modulo": element.id_modulo,
        "desc_modulo": element.desc_modulo,
        "sigla": element.sigla
      })
    });
    localStorage.setItem('modulos', JSON.stringify(mods));
  }

  private setTokenUser(data: any) {
    localStorage.setItem('token', JSON.stringify(data.token));
  }
}
